import type {
    FC
} from "react";
import {
    View
} from "react-native";
import type IQuestionnaireStatusProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    QuestionnairePartContentProps
} from "../../type";
import {
    CircleCheck as CircleCheckIcon,
    Info as InfoIcon
} from "lucide-react-native";
import {
    formatDateTime
} from "../../../../helpers/locale";
import {
    withQuestionnaireContext
} from "../../context";
import Card from "../../../card";
import Text from "../../../text";

const QuestionnaireStatusContent: FC<QuestionnairePartContentProps<IQuestionnaireStatusProps>> = ({
    customTheme: customThemeProp,
    context,
    style,
    ...props
}) => {
    const customTheme = customThemeProp ?? context.customTheme;

    const {
        iconSizes,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        activeLocale,
        localize
    } = NCoreUIKitLocalize.useContext(context.customLocalize);

    const {
        container: containerDynamicStyle
    } = useStyles({
        spaces
    });

    if(context.isSubmitted) {
        return <Card.Content>
            <View
                {...props}
                style={[
                    style,
                    stylesheet.container,
                    containerDynamicStyle
                ]}
                ref={context.contentRef}
                aria-live="polite"
                role="status"
                tabIndex={-1}
            >
                <CircleCheckIcon
                    color={colors.content.icon.success}
                    size={iconSizes.small}
                />
                <Text
                    customTheme={customTheme}
                    variant="labelMediumSize"
                    style={stylesheet.text}
                    color="high"
                >
                    {localize("questionnaire-submitted")}
                </Text>
                {
                    context.submittedAt === undefined ?
                        null
                    :
                        <Text
                            customTheme={customTheme}
                            variant="bodySmallSize"
                            style={stylesheet.time}
                            color="mid"
                        >
                            {formatDateTime({
                                date: context.submittedAt,
                                locale: activeLocale,
                                preset: "time"
                            })}
                        </Text>
                }
            </View>
        </Card.Content>;
    }

    if(!context.isDisabled) {
        return null;
    }

    return <Card.Content>
        <View
            {...props}
            style={[
                style,
                stylesheet.container,
                stylesheet.note,
                containerDynamicStyle
            ]}
        >
            <InfoIcon
                color={colors.content.icon.mid}
                size={iconSizes.small}
            />
            <Text
                customTheme={customTheme}
                style={stylesheet.text}
                variant="bodySmallSize"
                color="mid"
            >
                {localize("questionnaire-expired")}
            </Text>
        </View>
    </Card.Content>;
};
export default withQuestionnaireContext("Status", QuestionnaireStatusContent);
